function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { useCacheToken } from '@ant-design/cssinjs';
import React from 'react';
import version from '../version';
import { defaultTheme, DesignTokenContext } from './context';
import defaultSeedToken from './themes/seed';
import formatToken from './util/alias';
export var getComputedToken = function getComputedToken(originToken, overrideToken, theme) {
  var derivativeToken = theme.getDerivativeToken(originToken);

  var override = overrideToken.override,
      components = __rest(overrideToken, ["override"]); // Merge with override


  var mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
    override: override
  }); // Format if needed

  mergedDerivativeToken = formatToken(mergedDerivativeToken);

  if (components) {
    Object.entries(components).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      var componentTheme = value.theme,
          componentTokens = __rest(value, ["theme"]);

      var mergedComponentToken = componentTokens;

      if (componentTheme) {
        mergedComponentToken = getComputedToken(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
          override: componentTokens
        }, componentTheme);
      }

      mergedDerivativeToken[key] = mergedComponentToken;
    });
  }

  return mergedDerivativeToken;
}; // ================================== Hook ==================================

export default function useToken() {
  var _React$useContext = React.useContext(DesignTokenContext),
      rootDesignToken = _React$useContext.token,
      hashed = _React$useContext.hashed,
      theme = _React$useContext.theme,
      components = _React$useContext.components;

  var salt = "".concat(version, "-").concat(hashed || '');
  var mergedTheme = theme || defaultTheme;

  var _useCacheToken = useCacheToken(mergedTheme, [defaultSeedToken, rootDesignToken], {
    salt: salt,
    override: Object.assign({
      override: rootDesignToken
    }, components),
    getComputedToken: getComputedToken,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: formatToken
  }),
      _useCacheToken2 = _slicedToArray(_useCacheToken, 2),
      token = _useCacheToken2[0],
      hashId = _useCacheToken2[1];

  return [mergedTheme, token, hashed ? hashId : ''];
}